{
    "SectionHint": "You can individually specify the Agent Not-Available reason code used for calculating each of the 11 different statistic variants of total & average Not-Available Agent status time. Select the 11 codes below that Agent status time statistics will be individually measured for:",
    "NaCode01Label": "Not-Available Code 01:",
    "NaCode02Label": "Not-Available Code 02:",
    "NaCode03Label": "Not-Available Code 03:",
    "NaCode04Label": "Not-Available Code 04:",
    "NaCode05Label": "Not-Available Code 05:",
    "NaCode06Label": "Not-Available Code 06:",
    "NaCode07Label": "Not-Available Code 07:",
    "NaCode08Label": "Not-Available Code 08:",
    "NaCode09Label": "Not-Available Code 09:",
    "NaCode10Label": "Not-Available Code 10:",
    "NaCode11Label": "Not-Available Code 11:",
    "UseCodeDescriptionLabel": "Use Code Description In Agent N-A Code Related Stats:",
    "ResetCodesHeader": "Reset Codes",
    "ResetCodesHint": "If there are Agent Not-Available reason codes currently configured within your telephony environment and the first 11 of these are different from the current setting values shown above, then you can click the following button to default the setting values using the first ten detected codes.",
    "ResetCodesButtonText": "Reset Codes",
    "ResetCodesConfirmDialogHint": "Are you sure you wish to reset all Agent Not-Available reason code statistic settings to the first 11 codes currently configured within your telephony environment?",
    "NAME": "ACDCodesLanguage",
    "ACDCodesLanguage_SectionHeader": "Agent Not-Available Time Statistic Variants"
}